<template>
  <div class="ma-4">
    <v-card class="rounded-lg">
      <v-app-bar flat dense color="grey lighten-4" class="rounded-t-lg px-3">
        <v-btn icon small class="mr-2 grey lighten-3" @click="$router.go(-1)">
          <v-icon>navigate_before</v-icon>
        </v-btn>

        <span class="text-h6 font-weight-medium grey--text text--darken-3">
          Staff Missed Training Report
        </span>

        <v-spacer></v-spacer>
      </v-app-bar>

      <v-divider></v-divider>

      <v-card-text class="pa-6 grey lighten-5">
        <v-row dense>
          <v-col cols="12" md="3">
            <v-select
              label="Select Month"
              :items="monthOptions"
              v-model="selectedMonth"
              outlined
              dense
              hide-details
              class="rounded-lg"
              background-color="white"
              clearable
            ></v-select>
          </v-col>

          <v-col cols="12" md="3">
            <v-select
              label="Select Year"
              :items="yearOptions"
              v-model="selectedYear"
              outlined
              dense
              hide-details
              class="rounded-lg"
              background-color="white"
              clearable
            ></v-select>
          </v-col>

          <v-col cols="12" md="3">
            <v-select
              label="Select Staff"
              :items="users"
              item-text="Name"
              item-value="_id"
              v-model="selectedStaffIds"
              outlined
              dense
              hide-details
              class="rounded-lg"
              background-color="white"
              clearable
              multiple
            ></v-select>
          </v-col>

          <v-col cols="12" md="3" class="d-flex justify-center">
            <v-btn 
              color="primary"
              block
              height="40"
              class="rounded-lg"
              :loading="isLoading"
              elevation="1"
              @click="trainingQuery()"
            >
              <v-icon left>mdi-magnify</v-icon>
              Search
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Data Table -->
      <v-card-text class="pa-6">
        <v-data-table
          :page="page"
          :pageCount="pageCount"
          :server-items-length="itemCount"
          :options.sync="options"
          :headers="headers"
          :items="missedTrainings"
          sort-asc
          class="elevation-1 rounded-lg"
          :loading="isLoading"
          loading-text="Loading Missed Trainings"
          no-data-text="No trainings conducted for this period."
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 50],
            showFirstLastPage: true,
            'items-per-page-text': 'Rows per page:',
            class: 'rounded-lg',
          }"
        >
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
const url = require("../../client_config/config").url;
import {DateTime} from "luxon";

export default {
  mixins: [],
  components: {},
  data: () => ({
    headers: [
      {text: "Training Month", value: "trainingMonth"},
      {text: "Employee", value: "staffName"},
      {text: "Training Missed", value: "trainingMissed"},
      {text: "Training Subject", value: "TrainingSubject"},
      {text: "", value: "select"},

    ],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    employees: [],
    missedTrainings: [],
    isLoading: false,
    signed: false,
    role: localStorage.getItem('userRole'),
    state: localStorage.getItem('userState'),
    requiredField: [
      v => !!v || 'This is required',
    ],
    trainingID: "",
    token: localStorage.getItem('token'),
    users: [],
    selectedStaffIds: [],
    selectedMonth: null,
    selectedYear: null,
    page: 1,
    pageCount: 1,
    itemCount: 0,
    options: {},
  }),

  computed: {

    monthOptions() {
      return Array.from({ length: 12 }, (_, i) =>
        new Intl.DateTimeFormat('en-US', { month: 'long' }).format(new Date(2023, i, 1))
      );
    },

    yearOptions() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = Math.min(currentYear + 2, 2025);
      return Array.from({ length: endYear - startYear + 1 }, (_, i) => (startYear + i).toString()).reverse();
    },


    // fullMonth() {
    //   return this.reportFilters.month && this.reportFilters.year
    //     ? `${this.reportFilters.month} ${this.reportFilters.year}`
    //     : null;
    // },

  },

  created() {
    this.getEmployees();
  },

  mounted() {
  },

  watch: {
    options: {
      handler() {
        this.trainingQuery();
      },
      deep: true
    },
  },

  methods: {
    initialize() {
      this.trainings = [];
    },

    async getEmployees() {
      let endpoint = '';
      const companyIds = localStorage.getItem('userCompanies');

      endpoint = `${url}/users/state/${this.state}`;

      await axios.get(endpoint, {
        params: {
          Company: JSON.parse(companyIds)
        }
      }).then(res => {
        this.users = res.data.users;

        console.log({users: this.users});

      });
    },

    close() {
      this.dialog = false;
    },

    trainingQuery() {

      if (!this.selectedMonth || !this.selectedYear) {
        console.warn("Month or year not selected yet.");
        return;
      }

      this.trainings = []
      this.isLoading = true;

      let { page, itemsPerPage } = this.options;
      page = page || 1;
      itemsPerPage = itemsPerPage || 10;

      const selectedMonth = this.selectedMonth;
      const selectedYear = this.selectedYear;
      const yearNumber = parseInt(selectedYear, 10);
      const monthNumber = DateTime.fromFormat(selectedMonth, "MMMM").month;

      const startDate = DateTime.utc(yearNumber, monthNumber, 1).toFormat("yyyy-MM-dd");

      const endDate = DateTime.utc(yearNumber, monthNumber, 1).endOf("month").toFormat("yyyy-MM-dd");

      console.log("Start Date:", startDate);
      console.log("End Date:", endDate);


      let endpoint = `${url}/inservicetraining/missed-training`;

      axios.get(endpoint, {
        params: {
          page,
          limit: itemsPerPage,
          startDate: startDate,
          endDate: endDate,
          staffIds: this.selectedStaffIds,
        }
      }).then(response => {
        const {docs, totalPages, totalDocs} = response.data;

        this.missedTrainings = docs;
        this.pageCount = totalPages;
        this.itemCount = totalDocs;
      }).finally(() => {
        this.isLoading = false;
      });
    },
  }
}
</script>
<style scoped>
.v-data-table {
  border: 1px solid #e0e0e0;
}

.v-data-table ::v-deep .v-data-table__wrapper {
  overflow-x: auto;
}

.v-data-table ::v-deep tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.v-btn {
  text-transform: none;
  letter-spacing: 0;
}

.v-text-field ::v-deep .v-input__prepend-inner {
  margin-top: 8px !important;
}

.v-select ::v-deep .v-input__prepend-inner {
  margin-top: 8px !important;
}

.rounded-lg {
  border-radius: 8px !important;
}

.rounded-t-lg {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  #print {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }

  nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }

  body {
    margin: 1.6cm;
  }
}
</style>
